import { useLanguage } from '@/lib/i18n'
import { RouteLoading } from '@/features/system/RouteLoading'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/features/auth/auth-context'

export function RequireAuth() {
  useLanguage()
  const { profile, loading } = useAuth()
  const location = useLocation()

  if (loading) return <RouteLoading />
  if (!profile) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  return <Outlet />
}
